import { getCurrentInstance } from '@vue/composition-api/dist/vue-composition-api';

export const useMeta = (getOptionsMethod) => {
  const { set } = getCurrentInstance().proxy.$meta().addApp('custom');
  set(getOptionsMethod());
};
